import { render, staticRenderFns } from "./ConnectivityPackagePrices.vue?vue&type=template&id=1d8e1140&scoped=true&"
import script from "./ConnectivityPackagePrices.vue?vue&type=script&lang=js&"
export * from "./ConnectivityPackagePrices.vue?vue&type=script&lang=js&"
import style0 from "./ConnectivityPackagePrices.vue?vue&type=style&index=0&id=1d8e1140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e1140",
  null
  
)

export default component.exports